import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-professional-bodies-w.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-professional-bodies-w.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { ViewApplicationService } from "../../../view-application.service";
import { ViewApplicationProfessionalBodiesWConstants } from "./view-application-professional-bodies-w.constants";
import { CreateApplicationProfessionalBodiesWConstants } from "../../../../create-application/modules/w/create-application-professional-bodies-w/create-application-professional-bodies-w.constants";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { WayleaveService } from "../../../../../shared/services/modules/wayleave.service";
import { take, takeUntil } from "rxjs/operators";
let ViewApplicationProfessionalBodiesWComponent = class ViewApplicationProfessionalBodiesWComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    viewApplicationService;
    recipientSelectService;
    appController;
    changeDetectorRefs;
    wayLeaveService;
    professionalBodiesForm;
    saveBtnPlaceholder = ViewApplicationProfessionalBodiesWConstants.SAVE_BUTTON_PLACEHOLDER;
    markImplementingAgentAsNotApplicableLabel = CreateApplicationProfessionalBodiesWConstants.MARK_IMPLEMENTING_AGENT_AS_NOT_APPLICABLE_LABEL;
    markImplementingAgentAsNotApplicableFormControlName = CreateApplicationProfessionalBodiesWConstants.MARK_IMPLEMENTING_AGENT_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantToImplementingAgentDetailsFormControlName = CreateApplicationProfessionalBodiesWConstants.COPY_APPLICANT_DETAILS_TO_IMPLEMENTING_AGENT_FORM_CONTROL_NAME;
    copyApplicantDetailsToImplementingAgentLabel = CreateApplicationProfessionalBodiesWConstants.COPY_APPLICANT_DETAILS_TO_IMPLEMENTING_AGENT_LABEL;
    markEngineerAsNotApplicableLabel = CreateApplicationProfessionalBodiesWConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_LABEL;
    markEngineerAsNotApplicableFormControlName = CreateApplicationProfessionalBodiesWConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToEngineerFormControlName = CreateApplicationProfessionalBodiesWConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_FORM_CONTROL_NAME;
    copyApplicantDetailsToEngineerLabel = CreateApplicationProfessionalBodiesWConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_LABEL;
    markContractorAsNotApplicableLabel = CreateApplicationProfessionalBodiesWConstants.MARK_CONTRACTOR_AS_NOT_APPLICABLE_LABEL;
    markContractorAsNotApplicableFormControlName = CreateApplicationProfessionalBodiesWConstants.MARK_CONTRACTOR_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToContractorFormControlName = CreateApplicationProfessionalBodiesWConstants.COPY_APPLICANT_DETAILS_TO_CONTRACTOR_FORM_CONTROL_NAME;
    copyApplicantDetailsToContractorLabel = CreateApplicationProfessionalBodiesWConstants.COPY_APPLICANT_DETAILS_TO_CONTRACTOR_LABEL;
    implementingAgentFormControlName = CreateApplicationProfessionalBodiesWConstants.IMPLEMENTING_AGENT_FORM_CONTROL_NAME;
    engineerFormControlName = CreateApplicationProfessionalBodiesWConstants.ENGINEER_FORM_CONTROL_NAME;
    contractorFormControlName = CreateApplicationProfessionalBodiesWConstants.RESPONSIBLE_CONTRACTOR_FORM_CONTROL_NAME;
    showImplementingAgent = false;
    showEngineer = false;
    showContractor = false;
    implementingAgentDisableFilterBy = true;
    implementingAgentDisableAdd = true;
    implementingAgentDisableEditing = false;
    implementingAgentShowFields = true;
    implementingAgentIsInternal = false;
    implementingAgentGroups = [];
    implementingAgentLabel = CreateApplicationProfessionalBodiesWConstants.IMPLEMENTING_AGENT_LABEL;
    engineerDisableFilterBy = true;
    engineerDisableAdd = true;
    engineerDisableEditing = false;
    engineerShowFields = true;
    engineerIsInternal = false;
    engineerGroups = [];
    engineerLabel = CreateApplicationProfessionalBodiesWConstants.ENGINEER_LABEL;
    contractorDisableFilterBy = true;
    contractorDisableAdd = true;
    contractorDisableEditing = false;
    contractorShowFields = true;
    contractorIsInternal = false;
    contractorGroups = [];
    contractorLabel = CreateApplicationProfessionalBodiesWConstants.RESPONSIBLE_CONTRACTOR_LABEL;
    application;
    getSetProfessionalBodiesObservableSubscription;
    getStepMetaObservableSubscription;
    constructor(aflaModuleStrategyService, route, routerParamsService, viewApplicationService, recipientSelectService, appController, changeDetectorRefs, wayLeaveService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.viewApplicationService = viewApplicationService;
        this.recipientSelectService = recipientSelectService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.wayLeaveService = wayLeaveService;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getMetadata();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    handleRouteChange() {
        // this.getMetadata();
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("professionalBodiesForm");
        this.professionalBodiesForm = form;
    }
    getMetadata() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).pipe(takeUntil(this._destroy$), take(1)).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        try {
            this.implementingAgentGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.implementingAgentConsultantGroup);
            this.engineerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.engineerGroup);
            this.contractorGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.responsibleContractorGroup);
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
        this.getApplication();
    }
    getApplication() {
        const params = {
            $expand: `applicant($expand=groups),implementingAgent($expand=groups),engineer($expand=groups),contractor($expand=groups)`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetApplicationCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationProfessionalBodiesWConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.professionalBodiesForm.reset();
            const application = response.value[0];
            this.application = application;
            this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").setValue(this.application.applicant[0]);
            if (this.application.implementingAgent.length > 0) {
                this.showImplementingAgent = true;
                const recipientControl = this.professionalBodiesForm.get("implementingAgentRecipient");
                recipientControl.enable();
                recipientControl.setValue(this.application.implementingAgent[0]);
                this.professionalBodiesForm.get("markImplementingAgentAsNotApplicable").setValue(true);
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToImplementingAgent");
                copyControl.setValue(false);
                copyControl.enable();
            }
            else {
                this.showImplementingAgent = false;
                this.professionalBodiesForm.get("markImplementingAgentAsNotApplicable").setValue(false);
                const recipientControl = this.professionalBodiesForm.get("implementingAgentRecipient");
                recipientControl.disable();
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToImplementingAgent");
                copyControl.setValue(false);
                copyControl.disable();
            }
            if (this.application.engineer.length > 0) {
                this.showEngineer = true;
                const recipientControl = this.professionalBodiesForm.get("engineerRecipients");
                recipientControl.enable();
                recipientControl.setValue(this.application.engineer[0]);
                this.professionalBodiesForm.get("markEngineerAsNotApplicable").setValue(true);
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
                copyControl.setValue(false);
                copyControl.enable();
            }
            else {
                this.showEngineer = false;
                this.professionalBodiesForm.get("markEngineerAsNotApplicable").setValue(false);
                const recipientControl = this.professionalBodiesForm.get("engineerRecipients");
                recipientControl.disable();
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
                copyControl.setValue(false);
                copyControl.disable();
            }
            if (this.application.contractor.length > 0) {
                this.showContractor = true;
                const recipientControl = this.professionalBodiesForm.get("responsibleContractorRecipient");
                recipientControl.enable();
                recipientControl.setValue(this.application.contractor[0]);
                this.professionalBodiesForm.get("markContractorAsNotApplicable").setValue(true);
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToContractor");
                copyControl.setValue(false);
                copyControl.enable();
            }
            else {
                this.showContractor = false;
                this.professionalBodiesForm.get("markContractorAsNotApplicable").setValue(false);
                const recipientControl = this.professionalBodiesForm.get("responsibleContractorRecipient");
                recipientControl.disable();
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToContractor");
                copyControl.setValue(false);
                copyControl.disable();
            }
        }
        this.changeDetectorRefs.detectChanges();
    }
    onCopyApplicantDetailsToImplementingAgentChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("implementingAgentRecipient").disable();
        }
        else {
            this.professionalBodiesForm.get("implementingAgentRecipient").enable();
        }
    }
    onCopyApplicantDetailsToEngineerChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("engineerRecipients").disable();
        }
        else {
            this.professionalBodiesForm.get("engineerRecipients").enable();
        }
    }
    onCopyApplicantDetailsToContractorChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("responsibleContractorRecipient").disable();
        }
        else {
            this.professionalBodiesForm.get("responsibleContractorRecipient").enable();
        }
    }
    onMarkImplementingAgentAsNotApplicableChecked(event) {
        this.showImplementingAgent = event.currentTarget.checked;
        if (this.showImplementingAgent === false) {
            this.professionalBodiesForm.get("implementingAgentRecipient").disable();
            this.professionalBodiesForm.get("implementingAgentRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToImplementingAgent");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("implementingAgentRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToImplementingAgent");
            copyControl.enable();
        }
    }
    onMarkEngineerAsNotApplicableChecked(event) {
        this.showEngineer = event.currentTarget.checked;
        if (this.showEngineer === false) {
            this.professionalBodiesForm.get("engineerRecipients").disable();
            this.professionalBodiesForm.get("engineerRecipients").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("engineerRecipients").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
            copyControl.enable();
        }
    }
    onMarkContractorAsNotApplicableChecked(event) {
        this.showContractor = event.currentTarget.checked;
        if (this.showContractor === false) {
            this.professionalBodiesForm.get("responsibleContractorRecipient").disable();
            this.professionalBodiesForm.get("responsibleContractorRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToContractor");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("responsibleContractorRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToContractor");
            copyControl.enable();
        }
    }
    onBtnSaveClicked($event) {
        if (this.professionalBodiesForm.valid) {
            const applicantFormValue = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
            let implementingAgentRecipient = null;
            const professionalBodiesFormControl = this.professionalBodiesForm.get("implementingAgentRecipient");
            const copyApplicantDetailsToImplementingAgent = this.professionalBodiesForm.get("copyApplicantDetailsToImplementingAgent").value;
            const markImplementingAgentAsNotApplicable = this.professionalBodiesForm.get("markImplementingAgentAsNotApplicable").value;
            if (copyApplicantDetailsToImplementingAgent || markImplementingAgentAsNotApplicable) {
                if (copyApplicantDetailsToImplementingAgent) {
                    this.recipientSelectService.setRecipient(applicantFormValue, true, professionalBodiesFormControl, true);
                }
                const implementingAgentRecipientFormValue = this.professionalBodiesForm.get("implementingAgentRecipient").value;
                implementingAgentRecipient = RecipientUtils.removeRecipientProperties(implementingAgentRecipientFormValue);
            }
            let engineerRecipient = null;
            const engineerRecipientsFormControl = this.professionalBodiesForm.get("engineerRecipients");
            const copyApplicantDetailsToEngineer = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer").value;
            const markEngineerAsNotApplicable = this.professionalBodiesForm.get("markEngineerAsNotApplicable").value;
            if (copyApplicantDetailsToEngineer || markEngineerAsNotApplicable) {
                if (copyApplicantDetailsToEngineer) {
                    this.recipientSelectService.setRecipient(applicantFormValue, true, engineerRecipientsFormControl, true);
                }
                const engineerRecipientsFormValue = this.professionalBodiesForm.get("engineerRecipients").value;
                engineerRecipient = RecipientUtils.removeRecipientProperties(engineerRecipientsFormValue);
            }
            let responsibleContractorRecipient = null;
            const responsibleContractorRecipientFormControl = this.professionalBodiesForm.get("responsibleContractorRecipient");
            const copyApplicantDetailsToContractor = this.professionalBodiesForm.get("copyApplicantDetailsToContractor").value;
            const markContractorAsNotApplicable = this.professionalBodiesForm.get("markContractorAsNotApplicable").value;
            if (copyApplicantDetailsToContractor || markContractorAsNotApplicable) {
                if (copyApplicantDetailsToContractor) {
                    this.recipientSelectService.setRecipient(applicantFormValue, true, responsibleContractorRecipientFormControl, true);
                }
                const responsibleContractorRecipientFormValue = this.professionalBodiesForm.get("responsibleContractorRecipient").value;
                responsibleContractorRecipient = RecipientUtils.removeRecipientProperties(responsibleContractorRecipientFormValue);
            }
            const request = {
                implementingAgent: implementingAgentRecipient,
                engineer: engineerRecipient,
                contractor: responsibleContractorRecipient
            };
            this.getSetProfessionalBodiesObservableSubscription =
                this.wayLeaveService.getSetProfessionalBodiesObservable(this.application.id, request)
                    .subscribe({
                    next: response => {
                        this.getApplication();
                    }, error: error => {
                        this.appController.handleServerErrorMessage(ViewApplicationProfessionalBodiesWConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: ViewApplicationService },
        { type: RecipientSelectService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: WayleaveService }
    ];
};
ViewApplicationProfessionalBodiesWComponent = __decorate([
    Component({
        selector: "app-view-application-professional-bodies-w",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationProfessionalBodiesWComponent);
export { ViewApplicationProfessionalBodiesWComponent };
